import Choices from 'choices.js';

class TasacionesFunnelStep2 extends TasacionesFunnelManager {
    constructor() {
        super({
            stepNumber: 2,
            nextStepUrl: TasacionesConf.step3_url || '#'
        });
        
        this.formValidator = new FormValidator();
        this.priceCalculator = new PriceCalculator();

        this.initStep2Elements();
        this.popupData = this.readCatastroPopupData();
        this.popupDismissed = this.readPopupDismissedFlag();

        // Llamar bindEvents DESPUÉS de inicializar elementos
        this.bindEvents();
        
        this.updateFormByOperationType();

        // Hacer la llamada AJAX para acciones de sincronización
        this.syncOrder();

        if (this.shouldShowCatastroPopup()) {
            this.showCatastroModal();
        }
    }

    syncOrder(){
        // Hacer la llamada AJAX para sincronizar el pedido con el backend
        this.apiClient.backSyncActions().then(res => {
            if (res.success) {
                // Manejar la respuesta exitosa
                console.log('Pedido sincronizado con éxito:', res);
            } else {
                // Manejar el error
                console.error('Error al sincronizar el pedido:', res);
            }
        }).catch(err => {
            // Manejar el error de la solicitud AJAX
            console.error('Error de AJAX:', err);
        });
    }

    initStep2Elements() {
        this.elements = {
            tipoOperacion: document.getElementById('tipo_operacion'),
            destino: document.getElementById('destino'),
            finalidad: document.getElementById('finalidad'),
            estadoInmueble: document.getElementById('estado_inmueble'),
            form: document.getElementById('tasaciones-funnel-step-2'),
            submitBtn: document.getElementById('submit-btn-step-2'),
            backBtn: document.getElementById('back-btn-step-2'),
            popupDataInput: document.getElementById('catastro-tariff-popup-data'),
            modal: document.getElementById('catastro-tariff-modal'),
            modalTitle: document.getElementById('catastro-tariff-modal-title'),
            modalDescription: document.getElementById('catastro-tariff-modal-description'),
            modalError: document.getElementById('catastro-modal-error'),
            modalSecondaryBtn: document.getElementById('catastro-modal-secondary-btn'),
            modalPrimaryBtn: document.getElementById('catastro-modal-primary-btn'),
            priceElement: document.getElementById('tasaciones_funnel_price'),
        };

        this.destinoValue = this.elements.destino.value;
        console.log('this.destinoValue', this.destinoValue);

        this.elements.tipoOperacionChoices = new Choices(this.elements.tipoOperacion, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
            placeholder: true,
            placeholderValue: this.elements.tipoOperacion.getAttribute('placeholder') || 'Selecciona una opción',
        });

        this.elements.destinoChoices = new Choices(this.elements.destino, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
            placeholder: true,
            placeholderValue: this.elements.destino.getAttribute('placeholder') || 'Selecciona una opción',
        });

        this.elements.finalidadChoices = new Choices(this.elements.finalidad, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
            placeholder: true,
            placeholderValue: this.elements.finalidad.getAttribute('placeholder') || 'Selecciona una opción',
        });

        this.elements.estadoInmuebleChoices = new Choices(this.elements.estadoInmueble, {
            searchEnabled: false,
            itemSelectText: '',
            shouldSort: false,
            placeholder: true,
            placeholderValue: this.elements.estadoInmueble.getAttribute('placeholder') || 'Selecciona una opción',
        });

        this.validateForm();
    }

    // Sobrescribir el método bindEvents de la clase padre
    bindEvents() {
        if (this.elements.tipoOperacion) {
            this.elements.tipoOperacion.addEventListener('change', () => this.updateFormByOperationType());
        }

        // Validar formulario cada vez que un campo pierde el foco
        if (this.elements.form) {
            this.elements.form.querySelectorAll('select').forEach(input => {
                input.addEventListener('change', (e) => this.validateFormField(e.target));
            });
        }

        if (this.elements.form) {
            this.elements.form.addEventListener('submit', (e) => this.handleFormSubmit(e));
        }

        this.bindCatastroModalEvents();
    }

    bindCatastroModalEvents() {
        if (!this.elements.modalPrimaryBtn || !this.elements.modalSecondaryBtn) {
            return;
        }

        this.elements.modalPrimaryBtn.addEventListener('click', () => this.handleModalPrimaryAction());
        this.elements.modalSecondaryBtn.addEventListener('click', () => this.handleModalSecondaryAction());
    }

    validateFormField(field) {
        // Valida el formulario cada vez que un campo pierde el foco
        console.log('validateFormField', field.value);

        const formData = new FormData();
        formData.append(field.name, field.value);
        this.formValidator.validateStep2(formData);

        this.validateForm();
    }

    updateFormByOperationType() {
        const selectedValue = this.elements.tipoOperacion?.value;
        
        if (!this.elements.destino) {
            return;
        }

        // Quito selección y limpio opciones
        this.elements.destinoChoices.removeActiveItems();
        this.elements.destinoChoices.clearChoices();

        
        if (selectedValue === 'venta') {
            this.elements.destinoChoices.setChoices([
                { label: '¿Cuál será el uso del inmueble?', value: '', disabled: true },
                { label: 'Actualmente uso yo mismo el inmueble', value: 'actualmente lo uso yo' },
                { label: 'Actualmente el inmueble está alquilado', value: 'actualmente está alquilado' }
            ], 'value', 'label', true);
        } else {
            this.elements.destinoChoices.setChoices([
                { label: '¿Cuál será el uso del inmueble?', value: '', disabled: true },
                { label: 'Compro para usar yo mismo el inmueble', value: 'comprar para usarlo' },
                { label: 'Compro para poner el inmueble en alquiler', value: 'comprar para alquilarlo' },
                { label: 'Otros', value: 'otro tipo' }
            ], 'value', 'label', true);
        }

        this.elements.destinoChoices.setChoiceByValue(this.destinoValue);

    }

    validateForm() {
        // Validar el formulario y devolver true si es válido, false si no
        const formData = new FormData(this.elements.form);
        formData.append('tipo_operacion', this.elements.tipoOperacion.value);
        formData.append('destino', this.elements.destino.value);
        formData.append('finalidad', this.elements.finalidad.value);
        formData.append('estado_inmueble', this.elements.estadoInmueble.value);

        const errors = this.formValidator.validateStep2(formData, false);
        if (errors.length > 0) {
            this.elements.submitBtn.classList.add('disabled');
        } else {
            this.elements.submitBtn.classList.remove('disabled');
        }
        
        return errors.length === 0;
    }

    handleFormSubmit(event) {

        try {
            const formData = new FormData(this.elements.form);

            formData.append('tipo_operacion', this.elements.tipoOperacion.value);
            formData.append('destino', this.elements.destino.value);
            formData.append('finalidad', this.elements.finalidad.value);
            formData.append('estado_inmueble', this.elements.estadoInmueble.value);
            
            
            let errors = this.formValidator.validateStep2(formData);

            if (errors.length > 0) {
                event.preventDefault();
                return false;
            }

            // Al terminar la función sin event.preventDefault(); se envía el formulario.
            this.showLoading(true);
            
        } catch (error) {
            console.error('Error en handleFormSubmit:', error);
            event.preventDefault();
            this.showError('Error al guardar los datos');
            return false;
        }
    }

    readCatastroPopupData() {
        if (!this.elements.popupDataInput || !this.elements.popupDataInput.value) {
            return null;
        }

        try {
            return JSON.parse(this.elements.popupDataInput.value);
        } catch (error) {
            console.error('No se pudo parsear catastro popup data:', error);
            return null;
        }
    }

    readPopupDismissedFlag() {
        if (!this.popupData) {
            return false;
        }

        const popupDismissedValue = sessionStorage.getItem(this.getSessionStoragePopupDismissedFlagKey(this.popupData));
        return popupDismissedValue === 'true';
    }

    writePopupDismissedFlag(value) {
        if (!this.popupData) {
            return;
        }

        sessionStorage.setItem(this.getSessionStoragePopupDismissedFlagKey(this.popupData), value ? 'true' : 'false');
    }

    getSessionStoragePopupDismissedFlagKey(popupData) {
        const keyParts = [
            'tasaciones_show_catastro_popup_step_2',
            popupData.context,
            popupData.current_surface,
            popupData.catastro_surface,
            popupData.difference_type,
        ];
        return keyParts.join('|');
    }

    shouldShowCatastroPopup() {
        if (!this.popupData || !this.popupData.show_catastro_surface_popup) {
            return false;
        }

        if (this.popupData.difference_type === 'none') {
            return false;
        }

        if (this.popupDismissed){
            return false;
        }

        return true;
    }

    showCatastroModal() {
        if (!this.elements.modal || !this.popupData) {
            return;
        }

        this.hideModalError();

        const isHigher = this.popupData.difference_type === 'higher';
        const currentSurfaceText = `${this.popupData.current_surface} m²`;
        const catastroSurfaceText = `${this.popupData.catastro_surface} m²`;

        this.elements.modalTitle.textContent = 'La superficie de la vivienda no coincide con el Catastro';

        if (isHigher) {

            this.elements.modalDescription.innerHTML = '<p>Has indicado que tu vivienda tiene <b>'+ currentSurfaceText + '</b>, mientras que la información registrada en el Catastro refleja una superficie de <b>' + catastroSurfaceText + '</b> para esta vivienda.</p> <p>Debido a esta diferencia, tenemos que actualizar el importe siendo un total de <b>' + (this.popupData.price_formatted || '') + '</b>.</p> <p>Para poder continuar con el proceso, solo necesitamos que aceptes el importe de la tasación correspondiente a la superficie catastral oficial.</p>';

            this.elements.modalSecondaryBtn.textContent = 'Volver y revisar datos';

            this.elements.modalPrimaryBtn.textContent = 'Aceptar superficie y continuar';

        } else {

            this.elements.modalDescription.innerHTML = '<p>Has indicado que tu vivienda tiene <b>'+ currentSurfaceText + '</b>, pero el Catastro refleja una superficie de <b>' + catastroSurfaceText + '</b> para esta vivienda.</p> <p>Antes de continuar, confirma qué superficie deseas utilizar para la tasación.</p>';

            this.elements.modalSecondaryBtn.textContent = 'Continuar con la superficie introducida';
            
            this.elements.modalPrimaryBtn.textContent = 'Usar la superficie del Catastro';
        }


        this.elements.modal.setAttribute('aria-hidden', 'false');
        this.elements.modal.classList.add('is-open');
    }

    closeCatastroModal() {
        if (!this.elements.modal) {
            return;
        }

        this.elements.modal.setAttribute('aria-hidden', 'true');
        this.elements.modal.classList.remove('is-open');
    }

    handleModalSecondaryAction() {

        const isHigher = this.popupData?.difference_type === 'higher';

        if (isHigher) {
            const backUrl = this.elements.backBtn?.href || '#';
            window.location.href = backUrl;
            return;
        }

        this.writePopupDismissedFlag(true);

        this.closeCatastroModal();
    }

    async handleModalPrimaryAction() {
        await this.applyCatastroSurfaceAndContinue();
    }

    async applyCatastroSurfaceAndContinue() {
        if (!this.popupData?.context) {
            this.showModalError('No se ha encontrado el pedido actual. Recarga la página e inténtalo de nuevo.');
            return;
        }

        this.setModalButtonsDisabled(true);
        // this.showLoading(true);
        this.hideModalError();

        try {
            const response = await this.apiClient.updateTariffFromCatastroSurface(
                this.popupData.catastro_surface,
                'catastro'
            );

            if (!response?.success) {
                throw new Error(response?.message || 'No se pudo actualizar la tarifa con Catastro.');
            }

            // Actualizar el precio del title
            this.priceCalculator.updateStep2PriceCatastro(this.elements.priceElement, this.popupData.price, this.popupData.price_without_discount, this.popupData.catastro_surface);

            // this.showLoading(false);
            this.closeCatastroModal();
        } catch (error) {
            console.error('Error actualizando tarifa con Catastro:', error);
            // this.showLoading(false);
            this.showModalError(error.message || 'No se pudo actualizar la tarifa. Inténtalo de nuevo.');
            this.setModalButtonsDisabled(false);
        }
    }

    setModalButtonsDisabled(disabled) {
        if (this.elements.modalPrimaryBtn) {
            this.elements.modalPrimaryBtn.disabled = disabled;
        }
        if (this.elements.modalSecondaryBtn) {
            this.elements.modalSecondaryBtn.disabled = disabled;
        }
    }

    showModalError(message) {
        if (!this.elements.modalError) {
            return;
        }
        this.elements.modalError.textContent = message;
        this.elements.modalError.classList.remove('tasaciones-hidden');
    }

    hideModalError() {
        if (!this.elements.modalError) {
            return;
        }
        this.elements.modalError.textContent = '';
        this.elements.modalError.classList.add('tasaciones-hidden');
    }

}

// Hacer la clase disponible globalmente
window.TasacionesFunnelStep2 = TasacionesFunnelStep2;
